import IconAvatar from '@/components/icons/IconAvatar.vue'
import IconBattery from '@/components/icons/IconBattery.vue'
import IconBatteryCharging from '@/components/icons/IconBatteryCharging.vue'
import IconBuildCircle from '@/components/icons/IconBuildCircle.vue'
import IconCarKeyOutlined from '@/components/icons/IconCarKeyOutlined.vue'
import IconCircleCurrency from '@/components/icons/IconCircleCurrency.vue'
import IconDelete from '@/components/icons/IconDelete.vue'
import IconFire from '@/components/icons/IconFire.vue'
import IconHydrogen from '@/components/icons/IconHydrogen.vue'
import IconOfflineBolt from '@/components/icons/IconOfflineBolt.vue'
import IconOutlinedEVStation from '@/components/icons/IconOutlinedEVStation.vue'
import IconOutlinedMarkerCheck from '@/components/icons/IconOutlinedMarkerCheck.vue'
import IconPliers from '@/components/icons/IconPliers.vue'
import IconRvHookup from '@/components/icons/IconRvHookup.vue'
import IconTireRepair from '@/components/icons/IconTireRepair.vue'
import IconWaterDrop from '@/components/icons/IconWaterDrop.vue'
import IconWaterEc from '@/components/icons/IconWaterEc.vue'
import IconWeightOutlined from '@/components/icons/IconWeightOutlined.vue'
import VehiclesIcon from '@/components/ui-elements/custom-icons/VehiclesIcon.vue'
import { colorScheme } from '@/data/colorScheme'
import { h } from 'vue'
import { createVuetify, type IconProps, type IconSet, type ThemeDefinition } from 'vuetify'
import { mdi } from 'vuetify/iconsets/mdi'
import 'vuetify/styles'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customSvgNameToComponent: any = {
  vehiclesIcon: VehiclesIcon,
  circleCurrencyIcon: IconCircleCurrency,
  deleteIcon: IconDelete,
  outlinedMarkerCheck: IconOutlinedMarkerCheck,
  fireIcon: IconFire,
  pliers: IconPliers,
  waterDrop: IconWaterDrop,
  batteryCharging: IconBatteryCharging,
  offlineBolt: IconOfflineBolt,
  outlinedWeight: IconWeightOutlined,
  rvHookup: IconRvHookup,
  waterEc: IconWaterEc,
  outlinedEvStation: IconOutlinedEVStation,
  tireRepair: IconTireRepair,
  buildCircle: IconBuildCircle,
  hydrogen: IconHydrogen,
  battery: IconBattery,
  carKeyOutlined: IconCarKeyOutlined,
  avatar: IconAvatar,
}

const customSVGs: IconSet = {
  component: (props: IconProps) => h(customSvgNameToComponent[props.icon as string]),
}

const pwtTheme: ThemeDefinition = {
  dark: false,
  colors: {
    ...colorScheme,
    background: colorScheme.pwt_alabaster,
    primary: colorScheme.pwt_azure,
    secondary: colorScheme.pwt_light_grey,
    tertiary: colorScheme.pwt_dark_grey,
    accent: colorScheme.pwt_palatinate_blue,
    error: colorScheme.pwt_red,
    info: colorScheme.pwt_azure_80,
    success: colorScheme.pwt_green,
    warning: colorScheme.pwt_yellow,
  },
}

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    sets: {
      mdi,
      custom: customSVGs,
    },
  },
  theme: {
    defaultTheme: "pwtTheme",
    themes: {
      pwtTheme: pwtTheme,
    },
  },
  display: {
    mobileBreakpoint: 'md',
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    }
  }
})
